import React from "react";
import { Box, Icon, type IconProps } from "@chakra-ui/react";

export function ArrowLeftIcon({ width, height, ...props }: IconProps) {
  return (
    <Icon viewBox="0 0 24 24" fill="none" {...props}>
      <Box
        as="path"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m11.8.8-11 11m0 0 11 11m-11-11h22"
      />
    </Icon>
  );
}
